// src/services/descuentoService.js
import apiClient from './api';
import { API_CONFIG } from '../utils/constants';
import { Descuento } from '../models/Descuento';

export class DescuentoService {
  
  static async getAll() {
    try {
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.DESCUENTO);
      let descuentosData;
      if (response.data.success && response.data.data) {
        descuentosData = response.data.data;
      } else if (Array.isArray(response.data)) {
        descuentosData = response.data;
      } else {
        throw new Error('Formato de datos incorrecto del servidor');
      }
      if (!Array.isArray(descuentosData)) throw new Error('Los datos recibidos no son un array');
      return descuentosData.map((data) => new Descuento(data));
    } catch (error) {
      console.error('❌ Error al obtener descuentos:', error);
      throw new Error('Error al obtener descuentos: ' + error.message);
    }
  }

  static async getBySucursal(sucursalId) {
    try {
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.DESCUENTO}/sucursal/${sucursalId}`);
      let descuentosData;
      if (response.data.success && response.data.data) {
        descuentosData = response.data.data;
      } else if (Array.isArray(response.data)) {
        descuentosData = response.data;
      } else {
        throw new Error('Formato de datos incorrecto del servidor');
      }
      if (!Array.isArray(descuentosData)) descuentosData = [descuentosData];
      return descuentosData.map((data) => new Descuento(data));
    } catch (error) {
      console.error('❌ Error al obtener descuentos por sucursal:', error);
      throw new Error('Error al obtener descuentos por sucursal: ' + error.message);
    }
  }

  static async getById(id) {
    try {
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.DESCUENTO}/${id}`);
      let descuentoData;
      if (response.data.success && response.data.data) {
        descuentoData = response.data.data;
      } else {
        descuentoData = response.data;
      }
      return new Descuento(descuentoData);
    } catch (error) {
      console.error('❌ Error al obtener descuento:', error);
      throw new Error('Error al obtener descuento: ' + error.message);
    }
  }

  static async create(dataToSend) {
    try {
      console.log('🔍 CREATE - Data recibido:', dataToSend);

      if (!dataToSend.nombre || !dataToSend.nombre.trim())
        throw new Error('El nombre del descuento es requerido');
      if (!dataToSend.valor || dataToSend.valor <= 0)
        throw new Error('El valor del descuento debe ser mayor a 0');
      if (!dataToSend.fecha_inicio || !dataToSend.fecha_fin)
        throw new Error('Las fechas de inicio y fin son requeridas');
      if (new Date(dataToSend.fecha_fin) <= new Date(dataToSend.fecha_inicio))
        throw new Error('La fecha de fin debe ser posterior a la fecha de inicio');
      if (!dataToSend.productoIds || dataToSend.productoIds.length === 0)
        throw new Error('Debe seleccionar al menos un producto');
      if (dataToSend.limite_usos && (!dataToSend.cantidad_usos || dataToSend.cantidad_usos <= 0))
        throw new Error('Si activa límite de usos, debe especificar una cantidad válida');

      const payload = {
        nombre:        dataToSend.nombre,
        descripcion:   dataToSend.descripcion || null,
        valor:         parseFloat(dataToSend.valor),
        fecha_inicio:  dataToSend.fecha_inicio + 'T12:00:00', // ✅ evita resta UTC-5
        fecha_fin:     dataToSend.fecha_fin    + 'T12:00:00', // ✅ evita resta UTC-5
        estado:        dataToSend.estado || 'ACTIVO',
        id_sucursal:   dataToSend.id_sucursal,
        limite_usos:   dataToSend.limite_usos || false,
        cantidad_usos: dataToSend.limite_usos ? parseInt(dataToSend.cantidad_usos) : null,
        productoIds:   dataToSend.productoIds
      };

      console.log('📤 CREATE - Payload a enviar:', payload);
      const response = await apiClient.post(API_CONFIG.ENDPOINTS.DESCUENTO, payload);
      console.log('✅ CREATE - Respuesta del servidor:', response.data);

      return {
        success: response.data.success || true,
        message: response.data.message || 'Descuento creado exitosamente',
        data: response.data.data ? new Descuento(response.data.data) : null
      };
    } catch (error) {
      console.error('❌ Error al crear descuento:', error);
      throw new Error('Error al crear descuento: ' + (error.response?.data?.message || error.message));
    }
  }

  static async update(id, dataToSend) {
    try {
      console.log('🔍 UPDATE Service - ID recibido:', id);
      console.log('🔍 UPDATE Service - Data recibida:', dataToSend);

      if (!id) throw new Error('ID de descuento no proporcionado');
      if (!dataToSend.nombre || !dataToSend.nombre.trim())
        throw new Error('El nombre del descuento es requerido');
      if (!dataToSend.valor || dataToSend.valor <= 0)
        throw new Error('El valor del descuento debe ser mayor a 0');
      if (!dataToSend.fecha_inicio || !dataToSend.fecha_fin)
        throw new Error('Las fechas de inicio y fin son requeridas');
      if (new Date(dataToSend.fecha_fin) <= new Date(dataToSend.fecha_inicio))
        throw new Error('La fecha de fin debe ser posterior a la fecha de inicio');
      if (!dataToSend.productoIds || dataToSend.productoIds.length === 0)
        throw new Error('Debe seleccionar al menos un producto');

      // ✅ Limpiar el T si ya viene con hora, luego agregar T12:00:00
      const limpiarFecha = (f) => {
        const base = typeof f === 'string' && f.includes('T') ? f.split('T')[0] : f;
        return base + 'T12:00:00';
      };

      const payload = {
        nombre:        dataToSend.nombre.trim(),
        descripcion:   dataToSend.descripcion?.trim() || null,
        valor:         parseFloat(dataToSend.valor),
        fecha_inicio:  limpiarFecha(dataToSend.fecha_inicio), // ✅
        fecha_fin:     limpiarFecha(dataToSend.fecha_fin),    // ✅
        estado:        dataToSend.estado || 'ACTIVO',
        id_sucursal:   dataToSend.id_sucursal,
        limite_usos:   dataToSend.limite_usos || false,
        cantidad_usos: dataToSend.limite_usos ? parseInt(dataToSend.cantidad_usos) : null,
        productoIds:   dataToSend.productoIds
      };

      console.log('📤 UPDATE Service - Payload final:', payload);
      const response = await apiClient.put(`${API_CONFIG.ENDPOINTS.DESCUENTO}/${id}`, payload);
      console.log('✅ UPDATE Service - Respuesta:', response.data);

      return {
        success: response.data.success || true,
        message: response.data.message || 'Descuento actualizado exitosamente',
        data: response.data.data || null
      };
    } catch (error) {
      console.error('❌ UPDATE Service - Error:', error);
      throw new Error('Error al actualizar descuento: ' + (error.response?.data?.message || error.message));
    }
  }

  static async delete(id) {
    try {
      console.log('🗑️ DELETE - ID:', id);
      const response = await apiClient.delete(`${API_CONFIG.ENDPOINTS.DESCUENTO}/${id}`);
      console.log('✅ DELETE - Respuesta:', response.data);
      return {
        success: response.data.success || true,
        message: response.data.message || 'Descuento eliminado exitosamente'
      };
    } catch (error) {
      console.error('❌ Error al eliminar descuento:', error);
      throw new Error('Error al eliminar descuento: ' + error.message);
    }
  }

  static async incrementarUso(id) {
    try {
      console.log('➕ INCREMENTAR USO - ID:', id);
      const response = await apiClient.post(`${API_CONFIG.ENDPOINTS.DESCUENTO}/${id}/incrementar-uso`);
      console.log('✅ INCREMENTAR USO - Respuesta:', response.data);
      return {
        success: response.data.success || true,
        message: response.data.message || 'Uso incrementado exitosamente'
      };
    } catch (error) {
      console.error('❌ Error al incrementar uso:', error);
      throw new Error('Error al incrementar uso: ' + error.message);
    }
  }
}